import { Component, CSSProperties } from 'react';
import { TwitterPicker } from 'react-color';
import reactCSS from 'reactcss';

export type ColorPickerProps = {
  color: string;
  onChange: (payload: any) => void;
};

type StateT = {
  displayColorPicker: boolean;
  color: any;
};

type Theme = Record<
  'color' | 'swatch' | 'popover' | 'cover' | 'colorName' | 'holder',
  CSSProperties
>;

export default class ColorPicker extends Component<ColorPickerProps, StateT> {
  constructor(props: ColorPickerProps) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: this.props.color,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: ColorPickerProps) {
    if (nextProps.color !== this.state.color) {
      this.setState({ color: nextProps.color });
    }
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color: any) => {
    this.props.onChange(color.hex);
    this.setState({ color: color.hex });
  };

  render() {
    const styles = reactCSS<Theme>({
      default: {
        color: {
          width: '40px',
          height: '10px',
          borderRadius: '2px',
          background: `${this.state.color}`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
          marginLeft: '10px',
          float: 'left',
        },
        popover: {
          position: 'absolute',
          zIndex: 2,
          marginTop: '30px',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
        colorName: {
          display: 'block',
          float: 'left',
          marginLeft: '5px',
          fontWeight: 600,
          color: '#676767',
        },
        holder: {
          display: 'block',
          overflow: 'hidden',
          padding: '2px 0',
        },
      },
    });

    return (
      <div className="dixa-color-picker" style={styles.holder}>
        <div
          data-testid="swatch"
          style={styles.swatch}
          onClick={this.handleClick}
        >
          <div style={styles.color} />
        </div>
        <span style={styles.colorName}>{this.state.color}</span>
        {this.state.displayColorPicker === true ? (
          <div style={styles.popover} data-testid="popover">
            <div
              style={styles.cover}
              onClick={this.handleClose}
              data-testid="close"
            />
            <TwitterPicker
              width={285 as any}
              color={this.state.color}
              colors={[
                '#80B1EA',
                '#3D62AF',
                '#F8E81C',
                '#FF995B',
                '#FF4F3F',
                '#7ED321',
                '#21A675',
                '#B780CA',
                '#8E1CF2',
                '#4A4A4A',
              ]}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
